// This Privider is Obsolete.
// It is not removed because third-part Workspaces/Extentions use it as injection.
// (It was present in Workspace Files Template that we provide)

angular.module('mx.components').provider('mx.components.DataProviderRegistry', function dataProviderRegistryProvider() {
	const vm = this;

	function errorMessage() {
		console.error(
			'The provider "mx.components.DataProviderRegistry" / "mx.components.DataProviderRegistryProvider" is outdated and not in use anymore. Don\'t use it in your Workspaces/Extentions.'
		);
	}

	vm.register = () => errorMessage();

	vm.$get = [
		function () {
			errorMessage();
			return {
				get: () => errorMessage(),
				getData: () => errorMessage(),
			};
		},
	];
});
